import { BarbellIcon } from "../../ui/icons/job-offers/BarbellIcon";
import { CalendarIcon } from "../../ui/icons/job-offers/CalendarIcon";
import { CarIcon } from "../../ui/icons/job-offers/CarIcon";
import { ClockIcon } from "../../ui/icons/job-offers/ClockIcon";
import { CommunicationIcon } from "../../ui/icons/job-offers/CommunicationIcon";
import { DoctorIcon } from "../../ui/icons/job-offers/DoctorIcon";
import { DocumentIcon } from "../../ui/icons/job-offers/DocumentIcon";
import { EducationIcon } from "../../ui/icons/job-offers/EducationIcon";
import { EuroIcon } from "../../ui/icons/job-offers/EuroIcon";
import { HealthIcon } from "../../ui/icons/job-offers/HealthIcon";
import { HeartIcon } from "../../ui/icons/job-offers/HeartIcon";
import { LocationIcon } from "../../ui/icons/job-offers/LocationIcon";
import { MoonIcon } from "../../ui/icons/job-offers/MoonIcon";
import { PiggyBankIcon } from "../../ui/icons/job-offers/PiggyBankIcon";
import { SendIcon } from "../../ui/icons/job-offers/SendIcon";
import { StarIcon } from "../../ui/icons/job-offers/StarIcon";
import { SyringeIcon } from "../../ui/icons/job-offers/SyringeIcon";
import { TabletIcon } from "../../ui/icons/job-offers/TabletIcon";
import { TickIcon } from "../../ui/icons/job-offers/TickIcon";
import { UsersIcon } from "../../ui/icons/job-offers/UsersIcon";

const iconMap = {
  location: LocationIcon,
  euro: EuroIcon,
  calendar: CalendarIcon,
  moon: MoonIcon,
  car: CarIcon,
  education: EducationIcon,
  barbell: BarbellIcon,
  tablet: TabletIcon,
  piggyBank: PiggyBankIcon,
  users: UsersIcon,
  health: HealthIcon,
  document: DocumentIcon,
  doctor: DoctorIcon,
  syringe: SyringeIcon,
  communication: CommunicationIcon,
  heart: HeartIcon,
  clock: ClockIcon,
  send: SendIcon,
  tick: TickIcon,
  star: StarIcon,
};

export const getIcon = (iconKey: string) => {
  try {
    return iconMap[iconKey as keyof typeof iconMap];
  } catch (error) {
    return null;
  }
};
